import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';

const SuspendedPage = () => {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason') || '';

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center"
      style={{ background: 'linear-gradient(135deg,#1e1048 0%,#2d1b69 60%,#4a2a9e 100%)' }}>
      <div className="text-center px-4" style={{ maxWidth: '480px' }}>

        <div style={{ fontSize: '64px', marginBottom: '16px' }}>🔒</div>

        <h2 className="fw-bold text-white mb-3" style={{ fontFamily: "'Fredoka One',cursive" }}>
          Account Suspended
        </h2>

        <div className="card border-0 p-4 mb-4" style={{ borderRadius: '16px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)' }}>
          {reason ? (
            <>
              <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '15px', marginBottom: '8px' }}>
                Reason:
              </p>
              <p className="fw-semibold" style={{ color: 'white', fontSize: '16px', marginBottom: 0 }}>
                {reason}
              </p>
            </>
          ) : (
            <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '15px', marginBottom: 0 }}>
              Your account has been suspended. Please contact our support team for more information.
            </p>
          )}
        </div>

        <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '14px', marginBottom: '28px' }}>
          If you believe this is a mistake, please reach out and we'll look into it right away.
        </p>

        <a
          href="mailto:support@dreamybedtime.com"
          className="btn btn-lg rounded-pill fw-bold px-5 mb-3 d-block"
          style={{ background: '#6f42c1', color: 'white', border: 'none' }}
        >
          <i className="bi bi-envelope me-2"></i>Contact Support
        </a>

        <Link to="/" className="btn btn-outline-light rounded-pill px-4">
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default SuspendedPage;
